import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import { Suspense } from 'react';

import { useDataContext } from '../../contexts/DataContext';
import * as Components from '../../interactives/index';

import styles from '../../styles/blocks/chart-block.module.css';

export interface ChartBlockProps {
    name: string;
    title?: string;
    description?: string;
    data: unknown;
    className?: string | null;
    [key: string]: unknown;
}

function ChartBlock({
    name,
    title,
    description,
    data: blockData = null,
    className = null,
    ...props
}: ChartBlockProps) {
    const { data: contextData = null, filters, setFilters, isLoading } = useDataContext();
    const data = blockData || contextData;
    const ChartComponent = getComponentFromName(Components, `${name}-chart`);
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.isLoading]: isLoading,
                },
                className,
            ])}
        >
            {title !== null ? <h4 className={styles.title}>{title}</h4> : null}
            {description !== null ? (
                <div
                    className={styles.description}
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            ) : null}
            <Suspense fallback={null}>
                {ChartComponent !== null ? (
                    <ChartComponent
                        data={data}
                        filters={filters}
                        setFilters={setFilters}
                        {...props}
                        className={styles.chart}
                    />
                ) : null}
            </Suspense>
        </div>
    );
}

export default ChartBlock;
